export enum TypeContratoServico {
  PARCERIA_COMERCIAL_CNPJ = 'PARCERIA_COMERCIAL_CNPJ',
  PARCERIA_COMERCIAL_CPF = 'PARCERIA_COMERCIAL_CPF'
}
